import { StepperContext } from "./stepper.context";
import type { StepperProps } from "./types-stepper";
import { useStepper } from "./use-stepper";
import { StepperView } from "./view-stepper";

export function StepperRoot({ children, ...options }: StepperProps) {
  const viewModel = useStepper(options);

  return (
    <StepperContext.Provider value={viewModel}>
      <StepperView
        compact={viewModel.compact}
        orientation={viewModel.orientation}
        variant={viewModel.variant}
        testId={viewModel.testId}
        className={viewModel.className}
        style={viewModel.style}
        rest={viewModel.rest}
      >
        {children}
      </StepperView>
    </StepperContext.Provider>
  );
}
StepperRoot.displayName = "Stepper.Root";
